module.exports = __webpack_public_path__ + "static/media/lightbulb.678e64b9.svg";